// @ts-nocheck
/* eslint-disable */
export const flListIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.75 12L20.25 12" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.75 6L20.25 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.75 18L20.25 18" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'list' as const
};